<template>
  <result-page :initParams="initParams" :result="result" :backUrl="backUrl" :reportUrl="reportUrl" />
</template>


<script>
  import ResultPage from './ResultPage'
  import calculationService from "../api/calculationService";

  export default {
    props: {
      calculationId: null
    },

    computed: {
      backUrl() {
        return `/talo/${this.calculationId}`
      },
      reportUrl() {
        return `/laskuri/localapi/report/house/${this.calculationId}`
      }
    },

    data() {
      return {
        result: null,
        initParams: null
      };
    },

    created () {
      calculationService.getCalculationResult('house', this.calculationId)
        .then(result => this.result = result)

      calculationService.getCalculationInitParams('house', this.calculationId)
        .then(initParams => this.initParams = initParams)
    },

    components: {
      ResultPage
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/HouseResultPage.vue